import React, { useEffect, useState } from "react";
import logo from "../Assets/logo.svg";
import banner from "../Assets/Login-landing.png";
import "../Styles/Login.css";
import bottom from "../Assets/Login_BG_bottom.svg";
import cloud from "../Assets/Login_BG_top.svg";
import {
    Headset,
    Key,
    Eye,
    EnvelopeSimple,
    WarningCircle,
    EyeSlash,
} from "@phosphor-icons/react";
import PageLoader from "./loader/PageLoader";
import { loginUser } from "../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

const Login = () => {
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({ email: "", password: "" });
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [emailInputFocused, setEmailInputFocused] = useState(false);
    const [passInputFocused, setPassInputFocused] = useState(false);
    const [isLoading, setIsLoading] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { errorMessage } = useSelector((state) => state.auth);

    const [dbError, setDbError] = useState(errorMessage);

    const handleChange = (e) => {
        const { value, name } = e.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));

        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        setDbError("");
    };

    const validateEmail = (email) => {
        return typeof email === "string" && email.includes("@");
    };

    // Handle Submit
    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        let emailError = "";
        let passwordError = "";

        if (!validateEmail(formData.email)) {
            emailError = "Invalid email";
        }

        if (formData.email === "") {
            emailError = "Email is required";
        }

        if (formData.password === "") {
            passwordError = "Password is required";
        }

        if (emailError || passwordError) {
            setErrors({ email: emailError, password: passwordError });
            // console.log("Error Occured in Login");
            setIsLoading(false);
            return;
            
        } 
        else {
            try {
                setErrors({ email: "", password: "" });
                const resultAction = await dispatch(loginUser(formData));
                // console.log("Result action:", resultAction);
                const hotelId = await resultAction.payload.hotel_id;
                if (loginUser.rejected.match(resultAction)) {
                    const errorMessage =
                        resultAction.payload?.message || "Login failed";
                    console.log("Login rejected, error message:", errorMessage);
                    setDbError(errorMessage);
                } else if (loginUser.fulfilled.match(resultAction)) {
                    console.log("Login successful");
                    setDbError("");
                    try {
                        const response = await axiosInstance.get(
                            `/api/v1/hotels/${hotelId}/staff-members`,
                        );

                        // console.log(
                        //     "response from staff in login",
                        //     response.data.data,
                        // );
                        if (response.data.data.length > 0) {
                            navigate("/dashboard");
                        } else {
                            navigate("/onboard");
                        }
                    } catch (error) {
                        if (error.response.status === 404) navigate("/onboard");
                        else {
                            console.error(
                                "error occured while fetching staff info in login",
                                error.response.status,
                            );
                            return;
                        }
                    }
                }
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occured while making api request :", error);
                setErrors({ email: "", password: "" });
                setIsLoading(false);
            }
            finally{
                setIsLoading(false);
            }
        }
    };

    const inputClass = (error) =>
        error
            ? "border-[#FF7378] text-[#FF7378]"
            : "border-[#D0D2D4] text-[#737880]";

    return (
        <>
            {isLoading && <PageLoader />}
            <div>
                <header className="w-full flex justify-between h-20 items-center px-4 sm:px-8 lg:px-14 py-6 z-50 bg-white 2xl:px-28 2xl:py-20">
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={() => navigate("/")}
                    >
                        <img
                            src={logo}
                            alt="logo"
                            className="h-8 w-8 mr-2 2xl:h-14 2xl:w-14"
                        />
                        <h1 className="text-2xl 2xl:text-42xl text-[#050F4E]">
                            Alfred
                        </h1>
                    </div>
                    {/* <button className="flex justify-center items-center gap-2 h-10 w-36 sm:w-40 bg-[#FF7378] rounded-lg text-sm text-white 2xl:w-fit 2xl:px-6">
                    Request Demo{" "}
                    <Headset className="text-lg 2xl:text-22xl" weight="fill" />
                </button> */}
                </header>
                <main className="flex md:flex-row items-center justify-center h-full lg:pt-0 relative lg:mt-10">
                    <img
                        src={cloud}
                        alt="cloudImage"
                        className="absolute -top-0 left-0 w-full z-0"
                    />
                    <div className="w-[40%] md:w-[50%] flex items-end justify-center relative z-10 mb-8 lg:mb-0">
                        <img
                            src={banner}
                            alt="banner"
                            className="fixed bottom-24 md:w-[40%] 2xl:bottom-[20%] 2xl:w-60%] z-50"
                        />
                    </div>
                    <div className="w-[50%] lg:w-[40%] px-4 sm:px-8 lg:px-14 z-50 2xl:px-20 2xl:pl-36">
                        <form
                            className="px-8 py-4 text-sm lg:text-[16px]  bg-opacity-60 flex flex-col gap-3 lg:w-[373px] 2xl:w-fit"
                            onSubmit={handleSubmit}
                        >
                            <h3 className="font-semibold text-lg lg:text-xl">
                                Login
                            </h3>
                            {/* <p className="text-sm">
                            Enter credentials for{" "}
                            <span className="text-[#ff7378] font-semibold">
                                Taj Bengaluru
                            </span>
                        </p>
                        <span className="text-[#ff7378] cursor-pointer text-sm">
                            Change Hotel Id
                        </span> */}
                            <div className="flex flex-col gap-1 2xl:gap-2">
                                <label
                                    htmlFor="email"
                                    className={`font-semibold`}
                                >
                                    Email Id
                                </label>
                                <div
                                    className={`flex w-full border-[1.5px] rounded-lg p-[1px] 2xl:p-[2px] ${
                                        emailInputFocused
                                            ? "border-[#ff7378]"
                                            : "border-transparent"
                                    }`}
                                >
                                    <div
                                        className={`flex items-center gap-2 h-[36px] lg:h-[40px] p-[8px] rounded-lg w-full border-[1.5px] ${inputClass(
                                            errors.email,
                                        )}`}
                                        onFocus={() =>
                                            setEmailInputFocused(true)
                                        }
                                        onBlur={() =>
                                            setEmailInputFocused(false)
                                        }
                                    >
                                        <EnvelopeSimple
                                            className={`text-2xl font-bold ${inputClass(
                                                errors.email,
                                            )}`}
                                        />
                                        <input
                                            type="email"
                                            placeholder="Enter your email"
                                            className="outline-none border-none w-full  text-sm bg-transparent"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                {errors.email ? (
                                    <span className="text-[#E47186] text-xs flex items-center gap-1">
                                        <WarningCircle className="text-sm" />
                                        {errors.email}
                                    </span>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="flex flex-col gap-1 2xl:gap-2">
                                <label
                                    htmlFor="password"
                                    className={`font-semibold`}
                                >
                                    Password
                                </label>
                                <div
                                    className={`flex w-full border-[1.5px] rounded-lg p-[1px] 2xl:p-[2px] ${
                                        passInputFocused
                                            ? "border-[#ff7378]"
                                            : "border-transparent"
                                    }`}
                                >
                                    <div
                                        className={`flex items-center gap-2 h-[36px] lg:h-[40px] p-[8px] rounded-l-lg w-full border-[1.5px] border-r-0 ${inputClass(
                                            errors.password,
                                        )}`}
                                        onFocus={() =>
                                            setPassInputFocused(true)
                                        }
                                        onBlur={() =>
                                            setPassInputFocused(false)
                                        }
                                    >
                                        <Key
                                            className={`text-2xl font-bold ${inputClass(
                                                errors.password,
                                            )}`}
                                        />
                                        <input
                                            type={`${
                                                isPasswordVisible
                                                    ? "text"
                                                    : "password"
                                            }`}
                                            placeholder="Enter Password"
                                            className="outline-none border-none w-full text-sm bg-transparent"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <button
                                        className={`border-[1.5px] h-[36px] lg:h-[40px] p-[8px] rounded-r-lg flex items-center justify-center  ${inputClass(
                                            errors.password,
                                        )}`}
                                        type="button"
                                        onClick={() =>
                                            setIsPasswordVisible(
                                                !isPasswordVisible,
                                            )
                                        }
                                    >
                                        {isPasswordVisible ? (
                                            <EyeSlash className="text-xl text-black" />
                                        ) : (
                                            <Eye className="text-xl text-black" />
                                        )}
                                    </button>
                                </div>
                                {errors.password && (
                                    <span className="text-[#E47186] text-xs flex items-center gap-1">
                                        <WarningCircle className="text-sm" />
                                        {errors.password}
                                    </span>
                                )}
                                {dbError && (
                                    <span className="text-[#E47186] text-xs flex items-center gap-1">
                                        <WarningCircle className="text-sm" />
                                        {dbError}
                                    </span>
                                )}
                            </div>
                            <div>
                                {/* <p className="text-[#FF7378] text-[11px] font-semibold 2xl:text-2xl">
                                Forgot password?
                            </p> */}
                                <button
                                    className="w-full bg-[#FF7378] py-2 font-500 h-[34px] lg:h-[38px] rounded-lg mt-1  flex items-center justify-center"
                                    type="submit"
                                >
                                    Continue
                                </button>
                            </div>
                            <hr className="border-[#BFC4CC] text-sm lg:text-[16px] lg:my-1 border-[1.2px]" />
                            <div>
                                Not registered?{" "}
                                <span
                                    className="text-[#ff7378] cursor-pointer font-semibold"
                                    onClick={() => navigate("/signup")}
                                >
                                    Create your account
                                </span>
                            </div>
                        </form>
                    </div>
                </main>
                <img
                    src={bottom}
                    alt="bottomImg"
                    className="fixed bottom-0 lg:-bottom-32 left-0 w-full z-0"
                />
            </div>
        </>
    );
};

export default Login;
